import { Box, Button, GridedContent, IconChevronLeft, theme } from '@capitalise/ui-design-system';
import { PartnerReferral, PlanType } from 'enums/user-plan';
import useGetPlansData from 'modules/Business/hooks/useGetPlansData';
import { FunctionComponent, MouseEventHandler } from 'react';
import PlanCard from 'RemoteSubscription/PlanCard';
import PlanWrapper from 'RemoteSubscription/PlanWrapper';
import { useQueryGetPrices } from 'services/payment/queries';

export interface PlanStepProps {
  title: string;
  lead: string;
  hasPrevious: boolean;
  image?: FunctionComponent<{ width: string; height: string }>;
  onPreviousClick?: MouseEventHandler<HTMLButtonElement>;
  children?: JSX.Element;
  options: any;
}

const PlanStep = ({ title, lead, hasPrevious, onPreviousClick, ...rest }: PlanStepProps) => {
  const { data: prices } = useQueryGetPrices();
  const user = rest.options?.user?.toJS();
  const hasDiscount = user && user?.partnerReferral === PartnerReferral.discount;
  const plansContent = useGetPlansData(prices);
  return (
    <Box display="grid" gridTemplateRows="auto 1fr">
      <GridedContent rowGap={0}>
        <Box gridColumn={{ _: '1/5', sm: '3/7', lg: '5/9' }}>
          <Box display="flex" flexDirection="column">
            {hasPrevious && (
              <Box display="flex" alignSelf="start" pt={{ _: 'xsmall', md: 'medium' }}>
                <Button
                  baseColor="green"
                  leftIcon={<IconChevronLeft />}
                  onClick={onPreviousClick}
                  size="small"
                  variant="text"
                >
                  Previous
                </Button>
              </Box>
            )}
            <Box paddingY="medium">
              <Box typography="heading-32" color="grey-900" pb="3xsmall">
                {title}
              </Box>
              <Box
                typography="body-18"
                color="grey-700"
                dangerouslySetInnerHTML={{ __html: lead }}
              />
            </Box>
          </Box>
        </Box>
      </GridedContent>
      <GridedContent rowGap={0}>
        <Box gridColumn={{ _: '1/5', sm: '3/7', lg: '2/12' }}>
          <PlanWrapper discount={hasDiscount ? 25 : null}>
            {plansContent.map((item) => {
              const isFree = item.plan === PlanType.free;
              return (
                <PlanCard
                  key={item.name}
                  title={item.name}
                  description={item.header}
                  bgColor={isFree && theme.colors['grey-25']}
                  {...(isFree ? { active: true } : null)}
                  price={hasDiscount ? item.discountedMonthly : item.monthly}
                  caption="Excludes VAT"
                />
              );
            })}
          </PlanWrapper>
        </Box>
      </GridedContent>
    </Box>
  );
};

export default PlanStep;
